import { connect } from "react-redux";
import View from "./View";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as actions from "src/bepaid/store/model/Fetch/actions";
import * as PaymentPanelsActions from "src/ipm-platform/pages/Dashboard/BePaid/PaymentPanels/actions";
import * as PaymentActions from "src/ipm-shared/store/model/Payment/actions";
import * as GlobalUISelectors from "src/ipm-shared/components/GlobalUI/selectors";

const mapStateToProps = (state: RootState, props: any) => ({
  extraInfo: GlobalUISelectors.getExtraInfo(state, props.modalId),
  currencyId: GlobalUISelectors.getCurrentCurrencyId(state)
});

const mapDispatchToProps = {
  getInvoiceDetail: PaymentActions.selectPayment,
  refundCollectionPayment: PaymentPanelsActions.refundCollectionPayment,
  setControl: actions.setControl
};

export type IProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(View);
